import type { RouteLocationNormalizedLoaded } from "vue-router";

export function routeHasMiddleware(
  route: RouteLocationNormalizedLoaded,
  middlewareName: string
) {
  const middleware = route.meta.middleware;

  if (!middleware) {
    return false;
  }

  if (Array.isArray(middleware)) {
    return (middleware as string[]).includes(middlewareName);
  } else if (typeof middleware === "string") {
    return middleware === middlewareName;
  } else if (typeof middleware === "function") {
    // Handle the NavigationGuard case if needed
    // For example, if you have a mapping of function references to names
    // const middlewareFunctions = { requireAuth: requireAuthFunction };
    // return middleware === middlewareFunctions[middlewareName];
    return false; // Adjust logic as necessary
  } else if (middleware === undefined) {
    return false;
  }

  return false;
}
